const COPY_ISSUES = [
  ["titular", /titular(?:es)?|t[ií]tulos?|headline|\bh1\b|meta[\s-]?title|etiqueta\s+title|\btitle\b/i],
  ["cta", /\bcta\b|llamada\s+a\s+la\s+acci[oó]n|call[\s-]?to[\s-]?action/i],
  ["descripcion", /descripci[oó]n(?:es)?|metadescripci[oó]n(?:es)?|meta[\s-]?description/i],
];

function knownText(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}

function pushText(texts, value) {
  if (typeof value === "string" && value.trim()) texts.push(value);
}

function collectIssueText(result, checks) {
  const texts = [];
  pushText(texts, result?.summary);
  for (const item of result?.errors || []) {
    pushText(texts, item?.title);
    pushText(texts, item?.description);
    pushText(texts, item?.name);
    pushText(texts, item?.detail);
  }
  for (const item of result?.opportunities || []) {
    pushText(texts, item?.title);
    pushText(texts, item?.description);
  }
  for (const item of result?.recommendations || []) {
    if (typeof item === "string") pushText(texts, item);
    else {
      pushText(texts, item?.title);
      pushText(texts, item?.description);
      pushText(texts, item?.text);
    }
  }
  for (const check of checks || []) {
    if (check?.passed === false) {
      pushText(texts, check.name);
      pushText(texts, check.detail);
    }
  }
  return texts.join("\n");
}

export function normalizeRelaxiaBaseUrl(value = process.env.REACT_APP_RELAXIA_URL || "https://mejor-relax.vercel.app") {
  return String(value || "").trim().replace(/\/+$/, "");
}

export function knownSector(data) {
  const result = data?.result || {};
  return knownText(data?.sector, result.sector, result.industry);
}

export function knownBusiness(data) {
  const result = data?.result || {};
  return knownText(data?.negocio, result.negocio, result.business_name, result.business);
}

export function detectCopyIssues(result, checks) {
  const text = collectIssueText(result, checks);
  return COPY_ISSUES.filter(([, pattern]) => pattern.test(text)).map(([id]) => id);
}

export function buildRelaxiaUrl({ baseUrl, web, sector, negocio, fallos } = {}) {
  const root = normalizeRelaxiaBaseUrl(baseUrl);
  if (!root) return "";
  const params = new URLSearchParams();
  if (web) params.set("web", web);
  if (sector) params.set("sector", sector);
  if (negocio) params.set("negocio", negocio);
  if (fallos?.length) params.set("fallos", fallos.join(","));
  params.set("utm_source", "mejoratuweb");
  params.set("utm_medium", "referral");
  params.set("utm_campaign", "relaxia_textos");
  return `${root}/probar?${params.toString()}`;
}

export function trackRelaxiaCtaClick() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "relaxia_cta_click");
  } catch (_) {
    // A missing or broken tag must not block the outbound link.
  }
}
